class Storesingleton {}
export let storesingleton = new Storesingleton();